import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Sparkle, Copy } from "@phosphor-icons/react";
import { errMsg } from "@/lib/medicoes";

export default function IAMedicao({ medicaoId, tipos, onUse, beforeRun }) {
  const [loading, setLoading] = useState(null);
  const [res, setRes] = useState(null);
  const [ctx, setCtx] = useState("");
  const run = async (tipo) => {
    setLoading(tipo);
    try {
      if (beforeRun) await beforeRun();
      const { data } = await api.post(`/medicoes/${medicaoId}/ia`, { tipo, contexto: ctx });
      setRes({ tipo, texto: data.texto });
    } catch (e) { toast.error(errMsg(e, "Falha na IA")); }
    finally { setLoading(null); }
  };
  return (
    <div className="tce-card p-5 border-[#009C3B]/40" data-testid="ia-medicao">
      <div className="flex items-center gap-2 uppercase-label !text-[#009C3B] mb-3"><Sparkle size={14} weight="fill" /> Assistente IA da medição</div>
      <textarea value={ctx} onChange={(e) => setCtx(e.target.value)} rows={2} data-testid="ia-contexto"
                placeholder="Contexto opcional (ex.: dimensões medidas em campo, trechos, observações)…"
                className="tce-input w-full px-3 py-2 rounded-md text-xs mb-3" />
      <div className="flex flex-wrap gap-2">
        {tipos.map(([t, label]) => (
          <button key={t} type="button" disabled={!!loading} onClick={() => run(t)} data-testid={`ia-btn-${t}`}
                  className="px-3 py-2 rounded-md bg-[#009C3B]/15 border border-[#009C3B]/50 text-[#22C55E] hover:bg-[#009C3B]/25 text-xs font-medium disabled:opacity-50">
            {loading === t ? "Gerando…" : label}
          </button>
        ))}
      </div>
      {res && (
        <div className="mt-4">
          <pre data-testid="ia-resultado" className="whitespace-pre-wrap text-xs leading-relaxed bg-[#0F172A] border border-[#334155] rounded p-3 max-h-80 overflow-y-auto font-sans">{res.texto}</pre>
          <div className="flex gap-2 mt-2">
            {onUse && <button type="button" data-testid="ia-usar" onClick={() => onUse(res.tipo, res.texto)}
                              className="px-3 py-1.5 rounded-md bg-[#FFDF00] text-[#0F172A] text-xs font-medium">Usar este texto</button>}
            <button type="button" onClick={() => { navigator.clipboard?.writeText(res.texto); toast.success("Copiado"); }}
                    className="px-3 py-1.5 rounded-md border border-[#334155] text-xs flex items-center gap-1"><Copy size={12} /> Copiar</button>
          </div>
          <p className="text-[10px] text-[#64748B] mt-2">Texto gerado por IA: revise e valide tecnicamente antes de utilizar.</p>
        </div>
      )}
    </div>
  );
}
